<template>
  <el-config-provider :locale="locale">
    <router-view></router-view>
  </el-config-provider>
</template>
<script lang="ts" setup>
import zhCn from 'element-plus/es/locale/lang/zh-cn' // 新版路径
import { ElConfigProvider } from 'element-plus'

const locale = zhCn
</script>

<style lang="less"></style>
